export default __webpack_public_path__ + "static/media/36I-120858_-44001_0.2a8ee0cf.jpg";